import React from "react";
import { useBaseComponent } from "../../../../base/base-component";
import { IData, IState, IFamilyDetailProps, IFamilyDetailFormModel } from "./types/family-detail.types";
import { fetchData } from "./action/family-detail.action";
import { message } from "antd";
import { modelMapper, viewMapper } from "./action/family-detail.action";
import server from "../../../../server";
import FamilyDetailView from "../family-detail/family-detail.view";
import { Gender, Relation_Type } from "../../../../domains/models/employee";
import DataLoading from "../../../../common/loading-data";

const FamilyDetail = (props: IFamilyDetailProps) => {
    const {
        goToNextTab,
        employeeId,
    } = props;

    const {state, updateState} = useBaseComponent<IFamilyDetailProps, IState>(props, {
        initialState: () => ({
            // data: initialState,
            internal: {
                isFormValid: true,
            },
            external: {}
        }),
        onInit: () => onInit()
    });

    const onInit = async () => {
        if (employeeId) {
            let data: IData = await fetchData(employeeId);
            console.log("family details: ", data);
            if (data.family.length === 0) {
                data = {
                    family: [
                        {
                            name: "",
                            gender: "" as Gender,
                            mobileNumber: {
                                countryCode: "",
                                number: ""
                            },
                            relationType: "" as Relation_Type,
                        }
                    ]
                };
            }
            updateState('data', data);
        } else {
            message.error("Initialization Failed!")
        }
    }

    async function onSubmit(formValues: IFamilyDetailFormModel) {
        try {
            let familyDetailPayload = modelMapper(formValues);
            if (employeeId) {
                await server.employee.family.update(employeeId, familyDetailPayload)
                updateState('data.family', familyDetailPayload);
            }
            message.success('Family details submitted successfully!');
        } catch (error) {
            updateState('internal.isFormValid', false);
            message.error("Please fill in all required fields.");
        }
    }

    return (
        state.data === undefined ? <DataLoading title="Family Details"/> :
            <FamilyDetailView
                viewModel={viewMapper(state.data)}
                onSubmit={onSubmit}
                goToNextTab={goToNextTab}
            />
    )
};

export default FamilyDetail;
